<template lang="pug">
 
  #gcp-interface

</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import WebAudioService from 'src/services/WebAudioService'
import GCPService from 'src/services/GCPService'
import { map, randomInRange } from '@/helpers/MathUtils'

export default {

  name: 'gcp-interface',
  
  components: {},
  
  data() {
    return {}
  },
  
  computed: {
    ...mapState('browser', ['isMobile', 'isDesktop', 'debug']),
    ...mapState('app', ['firebase']),
    ...mapState('question', ['STATES'])
  },
  
  mounted() {

    this.strs = [
      'aaaaa',
      'bbbbb',
      'ccccc',
      'ddddd',
      'eeeee',
      'fffff',
      'ggggg',
      'hhhhh',
      'iiiii',
      'jjjjj',
      'kkkkk'
    ]

    this.index = 0;

    GCPService.on(GCPService.Events.Speech.Success, this.onSpeechSuccess); 
    GCPService.on(GCPService.Events.Success, this.onSuccess);
    GCPService.on(GCPService.Events.Error, this.onError);
    WebAudioService.on(WebAudioService.Events.Audio.Ready, this.onAudioReady);
  },
  
  beforeDestroy() {},
  
  methods: { 

    ...mapMutations('question', [
      'setResult',
      'setState',
      'setTranscription'
    ]),

    onAudioReady(base64){
      if(this.debug.dummy_api){
        this.dummyAPI();
      } else { 
        GCPService.speechToText(base64); 
      }
    },

    dummyAPI() {

      let response = {
        score: randomInRange(-1, 1), 
        magnitude: randomInRange(0, 4)
      }; 

      if(this.debug.magnitude){
        response.magnitude = this.debug.magnitude;
      }
 
      if(this.debug.score){
        response.score = this.debug.score;
      }

      console.log('DUMMY API - magnitude :: ' + response.magnitude + ' / score :: ' + response.score)
 
      this.setTranscription('Go home you filthy satanist stroke inducing teabag');

      TweenMax.delayedCall(3, () => {
        this.onSuccess(response);
      });
      
      this.index++;
    },

    onSpeechSuccess(transcription){ 
      if(transcription){
        this.setTranscription(transcription);
        GCPService.naturalLanguage(transcription, this.firebase.user_data.uid); 
      } else {
        // if empty (undefined) transcription returned
        this.error();
      }
    },

    onSuccess(response){   
      console.log('google interface :: onSuccess :: '+ response.score) 
      this.setResult({
        score: response.score,
        magnitude: response.magnitude
      });
    },

    onError(err){
      console.log('google interface :: onError :: ' ) 
      this.error();
      //this.setState(this.STATES.ERROR);
    },

    error(){
      this.setResult({
        score: null,
        magnitude: null
      });
    }
  },
  
  watch: {
    '$route'(val){
      if(val !== 'question'){ 
        this.setTranscription(null);
      }
    }
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#gcp-interface
</style>







